import { render, staticRenderFns } from "./cbdoil.vue?vue&type=template&id=24f1b060&scoped=true&"
import script from "./cbdoil.vue?vue&type=script&lang=js&"
export * from "./cbdoil.vue?vue&type=script&lang=js&"
import style0 from "./cbdoil.vue?vue&type=style&index=0&id=24f1b060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1b060",
  null
  
)

export default component.exports